import React, { useState, useEffect } from "react"
import dayjs from "dayjs"
import { StaticField } from "components-design-system"
import { Panel } from "components-design-system"
import { Flex } from "antd"
import "./ClinicalTrialsGov.scss"

// apis
import { useUserSettings } from "api/hooks"

const ClinicalTrialsGov = ({ clinicalTrialsData }) => {
  const { data: userSettings } = useUserSettings()
  const [items, setItems] = useState([
    {
      label: "NCT ID",
      key: "nct_number",
      type: "url",
    },
    {
      label: "Initial Release",
      key: "initial_release",
      type: "date",
    },
    {
      label: "Initial Results Release",
      key: "initial_results_release",
      type: "date",
    },
    {
      label: "Last Public Release",
      key: "last_public_release",
      type: "date",
    },
    {
      label: "Last Updated",
      key: "last_updated_on_ctg",
      type: "date",
    },
    {
      label: "Registration Submitted",
      key: "ctg_study_submitted",
      type: "date",
    },
    {
      label: "Results Posted",
      key: "ctg_results_posted",
      type: "date",
    },
    {
      label: "Corrections Expected",
      key: "prs_comments_corrections_expected",
      type: "number",
    },
    {
      label: "Delayed Certification Filed?",
      key: "delayed_certification_filed",
      type: "boolean",
    },
    {
      label: "Delayed Certification Filed Date",
      key: "delayed_certification_filed_date",
      type: "date",
    },
    {
      label: "Registration Posted",
      key: "ctg_study_posted",
      type: "date",
    },
    {
      label: "Results Submitted",
      key: "ctg_results_submitted",
      type: "date",
    },
  ])

  useEffect(() => {
    if (clinicalTrialsData) {
      let tempItems = [...items]
      for (let i = 0; i < tempItems.length; i++) {
        let curr = tempItems[i]
        if (clinicalTrialsData[curr.key] !== null && clinicalTrialsData[curr.key] !== undefined) {
          if (curr?.type === "date") {
            curr.value = dayjs(clinicalTrialsData[curr.key], "YYYY-MM-DD").format(userSettings?.date_format)
          } else if (curr?.type === "boolean") {
            curr.value = clinicalTrialsData[curr.key] ? "Yes" : "No"
          } else if (curr?.type === "url") {
            curr.value = clinicalTrialsData[curr.key]
            curr.url = `https://clinicaltrials.gov/study/${clinicalTrialsData[curr.key]}`
          } else {
            curr.value = clinicalTrialsData[curr.key]
          }
        }
      }
      setItems(tempItems)
    }
  }, [clinicalTrialsData])

  const displayItems = () => {
    return items.map((item) => {
      return (
        <StaticField
          key={item.key}
          title={item.label}
          value={item.value}
          url={item.url}
          style={{
            width: "50%",
            marginBottom: 12,
          }}
        />
      )
    })
  }

  return (
    <Panel
      title="CLINICALTRIALS.GOV"
      iconClassName="fa-light fa-globe"
      style={{ flex: 1 }}
    >
      <Flex wrap>{displayItems()}</Flex>
    </Panel>
  )
}

export default ClinicalTrialsGov
